import { FieldType } from '@dossierhq/core';
export function isAdminCloudinaryImage(component) {
    return component.type === 'CloudinaryImage';
}
export function isPublishedCloudinaryImage(component) {
    return component.type === 'CloudinaryImage';
}
export const CLOUDINARY_IMAGE_COMPONENT_TYPE = {
    name: 'CloudinaryImage',
    fields: [
        { name: 'publicId', type: FieldType.String, required: true },
        { name: 'width', type: FieldType.Number, integer: true, required: true },
        { name: 'height', type: FieldType.Number, integer: true, required: true },
        { name: 'alt', type: FieldType.String },
    ],
};
//# sourceMappingURL=CloudinaryImageComponent.js.map